import { Box, Stack } from "@chakra-ui/react";

import useGetRequirements from "../../../api/useGetRequirements";
import { useAccountLookupStore } from "../../../hooks/useAccountLookupStore";
import RequirementsDetailsTable from "./RequirementsDetailsTable";
import { RequirementsSearch } from "./RequirementsSearch";
import RequirementsSummariesTable from "./RequirementsSummariesTable";

const RequirementsAndActivityTab = () => {
  const accountNumber = useAccountLookupStore(state => state.accountNumber);
  const [fromProcessDate, toProcessDate, viewSelected] = useAccountLookupStore<
    string[]
  >(state => [state.fromProcessDate, state.toProcessDate, state.view]);

  const {
    data: requirementsData,
    refetch,
    isFetching,
  } = useGetRequirements(accountNumber, fromProcessDate, toProcessDate);

  return (
    <Stack spacing={0} overflow="auto" flex="1 1 0" height="full">
      <RequirementsSearch isLoading={isFetching} refetch={refetch} />
      <Box py={4} h="full" width="100%" overflow="auto">
        {requirementsData && viewSelected === "summary" && (
          <RequirementsSummariesTable
            requirementsSummaries={requirementsData.requirementsSummaries}
          />
        )}
        {requirementsData && viewSelected === "details" && (
          <RequirementsDetailsTable
            requirementsDetails={requirementsData.requirementsDetails}
          />
        )}
      </Box>
    </Stack>
  );
};

export default RequirementsAndActivityTab;
